export enum GAME_ATTRIBUTE_NAME {
  TITLE = 'title',
  UPDATED_AT = 'updatedAt'
}

// TODO change this number if pagination is needed for games
export const GAMES_PAGE_PAGE: number = 20000;
